import * as Turbo from "@hotwired/turbo"
import "@hotwired/turbo-rails"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import axios, { AxiosError } from "axios"
import React, { lazy } from "react"
import { createRoot } from "react-dom/client"
import toast, { Toaster } from "react-hot-toast"
import "../controllers"

// Visit the guide for more information: https://vite-ruby.netlify.app/guide/rails

// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

// Use Turbo to make transition between pages smoother
// We'll be able to remove this once we have fully migrated to a React SPA
Turbo.start()

// Set CSRF token for all axios requests
axios.defaults.headers.common["X-CSRF-Token"] =
  document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") || ""

// Set up React Query defaults
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: false,
    },
    mutations: {
      onError: (error) => {
        if (error instanceof AxiosError) {
          toast.error(error.response?.data?.error || error.message)
        }
      },
    },
  },
})

// Mount components introduced by the react_component helper from ApplicationHelper
document.addEventListener("turbo:load", () => {
  const nodes = document.querySelectorAll("[data-component]")
  Array.from(nodes).forEach((node) => {
    const Component = lazy(() => import(`../components/${node.getAttribute("data-component")}.tsx`))
    const dataProps = node.getAttribute("data-props")
    const props = dataProps ? JSON.parse(dataProps) : {}
    createRoot(node).render(
      <QueryClientProvider client={queryClient}>
        <Component {...props} />
        <Toaster />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    )
  })
})
